var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoided(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18457_11899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 10.5007C31.4401 10.5007 23.7258 14.1231 18.2551 19.8932C18.2163 19.9266 18.1678 19.9385 18.1312 19.9751C18.073 20.0333 18.0526 20.1108 17.9987 20.1733C13.0515 25.5255 10 32.655 10 40.5007C10 57.0421 23.4565 70.4997 39.9989 70.4997C56.5392 70.4997 69.9978 57.0421 69.9978 40.5007C69.9989 23.9583 56.5403 10.5007 40 10.5007ZM14.8352 40.4997C14.8352 34.7748 16.7794 29.5055 20.0118 25.2713L55.224 60.4867C50.991 63.7192 45.7249 65.6634 39.9989 65.6634C26.1234 65.6634 14.8352 54.3741 14.8352 40.4997ZM58.7742 57.1961L23.3014 21.7265C27.7499 17.7648 33.589 15.3349 40 15.3349C53.8744 15.3349 65.1637 26.6231 65.1637 40.4997C65.1626 46.9107 62.7337 52.7508 58.7742 57.1961Z",
    fill: "#C84B31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18457_11899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(10 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoided);
export default __webpack_public_path__ + "static/media/voided.2999bec289637bc4bb6d70f559d75d68.svg";
export { ForwardRef as ReactComponent };